import React from 'react'
import { Helmet } from 'react-helmet-async'

import BackLink from '@/components/misc/BackLink'
import PageTitle from '@/components/typography/PageTitle'
import { Card, CardContent } from '@/components/ui/card'
import { Container } from '@/components/ui/container'

type Props = React.ComponentProps<typeof Container> & {
  backLabel?: string
  backUrl?: string
}

const FirmDetailsNotFound: React.FC<Props> = ({
  backLabel,
  backUrl,
  ...props
}) => {
  const pageTitle = 'Firm not found'

  return (
    <Container {...props}>
      <Helmet title={pageTitle} />

      {backLabel && backUrl && <BackLink to={backUrl} label={backLabel} />}

      <PageTitle>{pageTitle}</PageTitle>

      <Card className="max-w-5xl">
        <CardContent>
          <p className="text-md mb-0">
            This firm's details could not be found.
          </p>
        </CardContent>
      </Card>
    </Container>
  )
}

export default FirmDetailsNotFound
